* {
  box-sizing: border-box;
}

:host {
  display: contents;
  max-width: 100%;
}

.wrapper {
  padding: 2px;
}
